import script from "./group-item-list.vue?vue&type=script&setup=true&lang=ts&generic=T%20extends%20GroupPickerItem"
export * from "./group-item-list.vue?vue&type=script&setup=true&lang=ts&generic=T%20extends%20GroupPickerItem"

const __exports__ = script;

export default __exports__